export const renderTime = (date) => {
    const postedDate = new Date(date);
    const currentDate = new Date();
    const diffInSeconds = Math.floor((currentDate - postedDate) / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    const diffInMonths = Math.floor(diffInDays / 30); // Approximate months
    const diffInYears = Math.floor(diffInMonths / 12); // Approximate years

    // Return based on the time difference
    if (diffInSeconds < 60) {
        return `Posted ${diffInSeconds} seconds ago`;
    } else if (diffInMinutes < 60) {
        return `Posted ${diffInMinutes} minutes ago`;
    } else if (diffInHours < 24) {
        return `Posted ${diffInHours} hours ago`;
    } else if (diffInDays < 30) {
        return `Posted ${diffInDays} days ago`;
    } else if (diffInMonths < 12) {
        return `Posted ${diffInMonths} months ago`;
    } else {
        return `Posted ${diffInYears} years ago`;
    }
}